import React from 'react';
import Badge from '@material-ui/core/Badge';
import Avatar from '@material-ui/core/Avatar';
import { Theme, makeStyles, withStyles, createStyles } from '@material-ui/core/styles';

import { Button, Card } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Markup } from 'interweave';
import { IRootState } from 'app/shared/reducers';

import './avatar-with-badge.scss';

const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      backgroundColor: '#44b700',
      display: "none",
      height: '10px',
      minWidth: '10px',
      borderRadius: '50%',
      color: '#44b700',
      boxShadow: `0 0 0 3px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: '$ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  })
)(Badge);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    large: {
      height: 52,
      width: 52,
    },
  })
);

export interface IAvatarWithBadgeProps {
  avatar: any;
  getPreviousStep?(): void;
  previousLink?: string;
  hideButton?: boolean;
  icon?: boolean;
  title?: string[];
  text?: string[];
  showAvatar?: boolean;
}

const AvatarWithBadge = (props: IAvatarWithBadgeProps) => {

  const history = useHistory();
  const classes = useStyles();

  const {
    avatar,
    getPreviousStep,
    previousLink,
    hideButton,
    icon,
    title,
    text,
    showAvatar
  } = props || {};

  const handleBack = () => {
    if (previousLink) {
      history.push(previousLink);
    } else {
      getPreviousStep();
    }
  };

  return (
    <div className={'header-avatar-badge' + (title?.length > 0 || text?.length > 0 && !showAvatar ? ' header-avatar-bottom-space' : '')}>
      <div className="avatar">
        {!hideButton && (
          <Button className="btn btn-back" onClick={() => handleBack()}>
            <ArrowBackIcon />
          </Button>
        )}

        {(title?.length > 0 || text?.length > 0) && avatar && Object.entries(avatar).length > 0 && !showAvatar && (
          <div className={classes.root}>
            <StyledBadge
              overlap="circular"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              variant="dot"
            >
              <Avatar className={classes.large} alt="Remy Sharp" src={avatar.image} />
            </StyledBadge>
          </div>
        )}
      </div>
      {((title?.length > 0 || text?.length > 0) || (title?.length > 1 && title[0] !== null)) && !showAvatar && (
        <Card className="header-badge-text-box">
          {icon && (
            <div className="check-icon">
              <img src={'/content/images/mobile-view/check.svg'} />
            </div>
          )}
          {title?.map((textItem, index) => {
            return (
              <div key={index}>
                {' '}
                <Markup className="text-msg-acceuil" content={textItem} />
              </div>
            );
          })}
          {text?.map((textItem, index) => {
            return (
              <React.Fragment key={index}>
                <Markup content={textItem} />
                <br />
              </React.Fragment>
            );
          })}
        </Card>
      )}
    </div>
  );
};
export default AvatarWithBadge;
